<template>
  <div class="row plan">
    <woot-button @click="addPlan" >Adicionar plano de cotação</woot-button>
    <table v-if="data.length" class="woot-table">
      <thead>
        <tr>
          <th>{{ $t('INTEGRATION_APPS.QUOTATION_PLAN.TABLE.NAME') }}</th>
          <th>{{ $t('INTEGRATION_APPS.QUOTATION_PLAN.TABLE.DESCRIPTION') }}</th>
          <th>{{ $t('INTEGRATION_APPS.QUOTATION_PLAN.TABLE.TYPE_VEHICLE') }}</th>
          <th>{{ $t('INTEGRATION_APPS.QUOTATION_PLAN.TABLE.ACTIONS') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td>{{ item.nome }}</td>
          <td>{{ item.descricao }}</td>
          <td>{{ item.tipoVeiculo }}</td>
          <td class="button-wrapper">
                <woot-button
                  v-tooltip.top="$t('CANNED_MGMT.EDIT.BUTTON_TEXT')"
                  variant="smooth"
                  size="tiny"
                  color-scheme="secondary"
                  icon="edit"
                  @click="openEditPopup(item)"
                />
                <woot-button
                  v-tooltip.top="$t('CANNED_MGMT.DELETE.BUTTON_TEXT')"
                  variant="smooth"
                  color-scheme="alert"
                  size="tiny"
                  icon="dismiss-circle"
                  class-names="grey-btn"
                  @click="openDeletePopup(item)"
                />
              </td>
        </tr>
      </tbody>
    </table>

    <woot-loading-state
        v-if="fetchingList && !data.length"
        :message="$t('CRM_MGMT.LOADING')"
      />
    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('CANNED_MGMT.DELETE.CONFIRM.TITLE')"
      :message="$t('CANNED_MGMT.DELETE.CONFIRM.MESSAGE')"
      :message-value="deleteMessage"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
    />


    <modal-edit-plan 
        v-if="showEditPopup" 
        :integration="integration" 
        :onClose="hideEditPopup"
        :plan="selectedResponse"
        :typeVehicles="typeVehicles"
    />

    <modal-add-plan 
        v-if="showAddPlan"
        :onClose="closeModal"
        :integration="integration"
        :typeVehicles="typeVehicles"
    />
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Modal from '../../../../../components/Modal.vue';
import ModalEditPlan from './ModalEditPlan.vue';
import ModalAddPlan from './ModalAddPlan.vue';
export default {
  name: 'Plan',
  components: { ModalEditPlan, Modal, ModalAddPlan },
  props: {
    integration: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showDeleteConfirmationPopup: false,
      selectedResponse: {},
      client_id: '',
      showEditPopup: false,
      fetchingList: false,
      showAddPlan: false,
    };
  },
  computed: {
    ...mapGetters({
      data: 'getPlanQuotations',
    }),
    typeVehicles(){
      return [
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.CAR'), id: "AUTO" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.TRUCK'), id: "CAMINHÃO" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.LIGHT_COMMERCIAL'), id: "COMERCIAL LEVE" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.ROAD_IMPLEMENT'), id: "IMPLEMENTO RODOVIÁRIO" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.AGRICULTURAL_MACHINE'), id: "MÁQUINA AGRÍCOLA" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.MOTORCYCLE'), id: "MOTO" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.NOT_IDENTIFIED'), id: "NÃO IDENTIFICADO" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.BUS'), id: "ÔNIBUS" },
        { label: this.$t('INTEGRATION_APPS.QUOTATION_PLAN.TYPES_VEHICLES.OTHERS'), id: "OUTROS" }
      ]
    },
    deleteConfirmText() {
      return `${this.$t('CANNED_MGMT.DELETE.CONFIRM.YES')} ${
        this.selectedResponse.nome
      }`;
    },
    deleteRejectText() {
      return `${this.$t('CANNED_MGMT.DELETE.CONFIRM.NO')} ${
        this.selectedResponse.nome
      }`;
    },
    deleteMessage() {
      return ` ${this.selectedResponse.nome}?`;
    },
  },
  mounted() {
    this.fetchingList = true;
    const { client_id } = this.integration.hooks[0].settings;
    this.client_id = client_id;
    this.$store.dispatch('getPlanQuotationByCompany', client_id)
    .finally(() => {
      this.fetchingList = false;
    });
  },
  methods: {

    addPlan() {
      this.showAddPlan = true;
    },

    closeModal() {
      this.showAddPlan = false;
    },
    openDeletePopup(response) {
      this.showDeleteConfirmationPopup = true;
      this.selectedResponse = response;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    confirmDeletion() {
      this.closeDeletePopup();
      this.$store.dispatch('deletePlanQuotation', this.selectedResponse.id)
        .then(() => {
          this.showAlert(this.$t('INTEGRATION_APPS.QUOTATION_PLAN.DELETE.API.SUCCESS_MESSAGE'));
        })
        .catch(() => {
        this.showAlert(this.$t('INTEGRATION_APPS.QUOTATION_PLAN.DELETE.API.ERROR_MESSAGE'));
        });
    },

    openEditPopup(response) {
      this.showEditPopup = true;
      this.selectedResponse = response;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },

    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
  }
};
</script>

<style>
.plan {
  margin-top: 1rem;
}
</style>